<template>
  <transition name="modal">
    <div class="text-left modal-mask fb-modal" v-show="showModal" @click="layerClick" id="modalCheck">
      <div class="modal-wrapper" @click="closeModal" >
        <div class="modal-container">
          <div class="modal-header">
            <h6>არ გამოტოვო სიახლეები მოიწონეთ ჩვენი გვერდი</h6>
          </div>

          <div class="modal-body" >
            <div
              class="fb-page"
              data-href="https://www.facebook.com/abiturige"
              data-tabs=""
              data-width=""
              data-height=""
              data-small-header="false"
              data-adapt-container-width="true"
              data-hide-cover="false"
              data-show-facepile="true"
            ></div>
          </div>

          <!-- <div class="modal-footer">
            <button class="btn btn-sm btn-danger" @click="closeModal">დახურვა</button>
          </div> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },

    layerClick(e) {
      if (e.target.id == 'modalCheck') {
        this.closeModal();
      }
    },
  },
  mounted() {
    const lastFbPopup = parseInt(localStorage.getItem('lastFbPopup_5'));
    if (lastFbPopup) {
      const hoursDifference = Math.floor((Date.now() - lastFbPopup) / 1000 / 60 / 60);
      if (hoursDifference <= 2) {
        return;
      }
    }
    setTimeout(() => {
      localStorage.setItem('lastFbPopup_5', Date.now());
      this.showModal = true;
    }, 4000);
  },
};
</script>

<style>
</style>
